import React from 'react';
import { CheckCircleIcon, XCircleIcon, AlertCircleIcon } from 'lucide-react';
export type EligibilityStatus = 'GREENLISTED' | 'NEEDS_EXEMPTION' | 'AUTO_REJECT';
interface EligibilityBadgeProps {
  status: EligibilityStatus;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  reason?: string;
}
const EligibilityBadge: React.FC<EligibilityBadgeProps> = ({
  status,
  size = 'md',
  showText = true,
  reason
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'GREENLISTED':
        return {
          icon: <CheckCircleIcon className={size === 'sm' ? 'w-3 h-3' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4'} data-id="element-102" />,
          text: 'Greenlisted',
          bgColor: 'bg-green-50',
          textColor: 'text-green-700',
          borderColor: 'border-green-100'
        };
      case 'NEEDS_EXEMPTION':
        return {
          icon: <AlertCircleIcon className={size === 'sm' ? 'w-3 h-3' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4'} data-id="element-103" />,
          text: 'Exemption Required',
          bgColor: 'bg-primary-50',
          textColor: 'text-primary-700',
          borderColor: 'border-primary-100'
        };
      case 'AUTO_REJECT':
        return {
          icon: <XCircleIcon className={size === 'sm' ? 'w-3 h-3' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4'} data-id="element-104" />,
          text: 'Not Eligible',
          bgColor: 'bg-red-50',
          textColor: 'text-red-700',
          borderColor: 'border-red-100'
        };
      default:
        return {
          icon: <CheckCircleIcon className={size === 'sm' ? 'w-3 h-3' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4'} data-id="element-105" />,
          text: 'Eligible',
          bgColor: 'bg-gray-50',
          textColor: 'text-gray-700',
          borderColor: 'border-gray-100'
        };
    }
  };
  const config = getStatusConfig();
  return <div className="relative inline-flex items-center group" data-id="element-106">
      <div className={`flex items-center ${size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'} rounded-full ${config.bgColor} ${config.textColor} ${size === 'sm' ? '' : 'border'} ${config.borderColor}`} data-id="element-107">
        <span className="mr-1" data-id="element-108">{config.icon}</span>
        {showText && <span className="font-medium" data-id="element-109">{config.text}</span>}
      </div>
      {reason && <div className="invisible group-hover:visible absolute bottom-full left-0 mb-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 p-3 text-sm z-[100]" data-id="element-110">
          <div className="text-left" data-id="element-111">
            <h4 className="font-medium text-gray-900 mb-1" data-id="element-112">
              Eligibility Status
            </h4>
            <p className="text-gray-700 text-xs" data-id="element-113">{reason}</p>
          </div>
          <div className="absolute bottom-0 left-4 transform translate-y-1/2 rotate-45 w-2 h-2 bg-white border-r border-b border-gray-200" data-id="element-114"></div>
        </div>}
    </div>;
};
export default EligibilityBadge;